import { useEffect, useState } from 'react';
import { DEMO_ASSETS } from '../content/assets';

function PlaceholderFrame({ asset, chrome, className, children }) {
  return (
    <figure className={`bv-demo ${chrome === 'none' ? 'bv-demo-bare' : ''} ${className}`.trim()} data-asset-id={asset.id} data-placeholder="true">
      <div className="bv-demo-frame">
        {chrome !== 'none' && (
          <div className="bv-demo-meta">
            <span className="bv-demo-flag">Simulated visualization</span>
            <span className="bv-demo-name">{asset.label}</span>
          </div>
        )}
        {chrome === 'none' && <span className="sr-only">Simulated visualization</span>}
        <div className="bv-demo-body">{children}</div>
        {chrome !== 'none' && (
          <figcaption className="bv-demo-caption">
            {asset.caption}
            <span className="bv-demo-path">{asset.publicPath}</span>
          </figcaption>
        )}
      </div>
    </figure>
  );
}

export default function DemoAsset({ id, fallback = null, className = '', chrome = 'full' }) {
  const asset = Object.values(DEMO_ASSETS).find((a) => a.id === id);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [asset?.src]);

  if (!asset) return null;

  if (asset.src && !failed) {
    return (
      <figure className={`bv-demo bv-demo-live ${chrome === 'none' ? 'bv-demo-bare' : ''} ${className}`.trim()} data-asset-id={asset.id}>
        <div className="bv-demo-frame">
          {asset.type === 'video' ? (
            <video
              src={asset.src}
              autoPlay
              muted
              loop
              playsInline
              onError={() => setFailed(true)}
            />
          ) : (
            <img src={asset.src} alt={asset.label} onError={() => setFailed(true)} />
          )}
        </div>
        {chrome !== 'none' && asset.caption && <figcaption className="bv-demo-caption">{asset.caption}</figcaption>}
      </figure>
    );
  }

  return (
    <PlaceholderFrame asset={asset} chrome={chrome} className={className}>
      {fallback}
    </PlaceholderFrame>
  );
}
